export default __webpack_public_path__ + "static/media/SCR.10b47675.png";